<template>
  <div>
    <div id="payment-element" class="my-4"></div>

    <div class="form-group" :class="{'-has-error' : errors.terms.length > 0}">
      <input
        type="checkbox"
        class="form-check-input inline"
        v-model="form.terms"
        required
      >

      <p class="inline ml-2" v-if="dashboardConfig.legal.terms">
        Aceito os <a :href="dashboardConfig.legal.terms" target="_blank" class="link">Termos de Uso</a>
      </p>

      <p class="description" v-if="errors.terms.length > 0">
        {{ errors.terms[0] }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    plan: Number,
    errors: Object,
    form: Object,
  },

  data() {
    return {
      elements: null,
      payment: null,
    };
  },

  methods: {
    async subscribe() {
      return this.$stripe.confirmPayment({
        elements: this.elements,
        redirect: 'if_required',
      });
    },
  },

  async mounted() {
    this.$emit('loading');
    await this.$store.dispatch('credits/registerIntentCreate');

    this.elements = this.$stripe.elements({ clientSecret: this.intent.clientSecret });
    this.payment = this.elements.create('payment');
    this.payment.mount('#payment-element');
    this.payment.on('ready', this.$emit.bind(this, 'loaded'));
  },

  computed: {
    ...mapState('credits', {
      intent: 'intent',
    }),

    ...mapState('dashboard', [
      'dashboardConfig',
    ]),
  },

  beforeUnmount() {
    this.payment.destroy();
  },
};
</script>
